import { WithFetchDatasByIdFromCMS } from 'modules/shared-cms/hocs';

import { ActualiteLoader } from './actualite-component-loader';
import { QUERY } from './actualite-query';
import { ActualiteProps } from './actualite-type';

const enhancer = WithFetchDatasByIdFromCMS<ActualiteProps>(QUERY, ActualiteLoader, 'findActualiteContent');
export default enhancer;
